import { defineStore } from 'pinia'

export const useAuth = defineStore('auth', () => {
  const user = ref(null)
  const lots = ref([])

  const getUser = async () => {
    try {
      user.value = await useDirectus().currentUser()
    } catch (e) {
      if (e.response.status == 401) {
        user.value = null
      }
    }

    try {
      lots.value = await useDirectus().readItems('lots', {
        fields: ['*', 'promotion.name', 'users.directus_users_id.first_name', 'users.directus_users_id.email'],
      })
    } catch (e) {}
  }

  const logout = async () => {
    await useDirectus().log('Déconnexion')
    await useDirectus().client.logout()
    navigateTo('/login')
  }

  return { user, logout, getUser, lots }
})
